import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const run = async () => {
      try {
        await exchangeSession(sessionId);
        window.history.replaceState(null, "", location.pathname);
        navigate("/shortlist", { replace: true });
      } catch {
        toast.error("Google sign-in could not be completed. Please try again.");
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    };
    run();
  }, [exchangeSession, location, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] grid place-items-center" data-testid="auth-callback">
      <div className="text-center">
        <Logo />
        <p className="mt-6 text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">Signing you in&hellip;</p>
      </div>
    </div>
  );
}
